namespace app.support.identidades {
    "use strict";

    export class ConsultarApresentacaoUsuariosQuery {

        public usuarios: string[] = [];
    }

    export class IdentidadesService {

        private identidadesApi: string;
        private loginENomeApresentacaoCache: Map<string, string> = new Map<string, string>();

        /** ngInject **/
        constructor(private $http: ng.IHttpService,
                    private $q: ng.IQService,
                    private properties: app.support.constants.Properties) {
            this.identidadesApi = `${this.properties.apiUrl}/integracoes-identidades/api`;
        }

        /**
         * Busca no backend após normalizar e filtras logins repetidos, faz request apenas com os logins que ainda
         * não foram consultados e com lowercase.
         * @param loginUsuarios map de logins com o nome de apresentação, login é retornado como foi consultado upper
         * ou lower case.
         */
        public getNomeApresentacao(loginUsuarios: string[]): ng.IPromise<Map<string, string>> {
            const logins = this.filtrarLogins(loginUsuarios);
            const loginsUpperCase = this.filtrarUpperCase(logins);
            let resultado: Map<string, string> = new Map<string, string>();
            const cmd = new ConsultarApresentacaoUsuariosQuery();

            logins.forEach(login => {
                const loginLowerCase = login.toLowerCase();
                if (Object.keys(this.loginENomeApresentacaoCache).indexOf(loginLowerCase) === -1) {
                    cmd.usuarios.push(loginLowerCase);
                } else {
                    resultado[login] = this.loginENomeApresentacaoCache[loginLowerCase];
                }
            });

            if (cmd.usuarios.length > 0) {
                const url = `${this.identidadesApi}/acessos/recuperar-apresentacao-usuarios`;
                return this.$http.post<Map<string, string>>(url, cmd)
                    .then((responseIdentidades) => {
                        // @ts-ignore
                        Object.entries(responseIdentidades.data).forEach(([login, nomeApresentacao]) => {
                            this.loginENomeApresentacaoCache[login] = nomeApresentacao;
                            let loginBuscado = login;
                            if (loginsUpperCase.indexOf(login.toUpperCase()) !== -1) {
                                loginBuscado = login.toUpperCase();
                            }
                            resultado[loginBuscado] = this.loginENomeApresentacaoCache[login];
                        });
                        return resultado;
                    });
            } else {
                return this.$q.resolve(resultado);
            }
        }

        private filtrarLogins(loginUsuarios: string[]): string[] {
            let logins: Set<string> = new Set<string>();
            loginUsuarios.filter(l => Boolean(l)).forEach(login => logins.add(login));
            return Array.from(logins);
        }

        private filtrarUpperCase(loginUsuarios: string[]): string[] {
            let loginsUpperCase = [];
            loginUsuarios.forEach(login => {
                if (login === login.toUpperCase()) {
                    loginsUpperCase.push(login);
                }
            });
            return loginsUpperCase;
        }
    }

    angular.module("app.support.identidades").service("identidadesService", IdentidadesService);
}